import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
// S1
import BaseMixer from "@/router/views/BaseMixer";
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import calendarEvents from "@fullcalendar/core";
let EcCalendar = /** @class */ (() => {
    let EcCalendar = class EcCalendar extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.popoverTarget = "";
            this.popoverData = "";
            this.classesArray = [
                {
                    className: "calendar-event-primary text-white",
                },
                {
                    className: "calendar-event-info text-white",
                },
                {
                    className: "calendar-event-warning text-white",
                },
                {
                    className: "calendar-event-success text-white",
                },
            ];
        }
        handleMonthChange(payLoad) {
            this.$emit("onnavigationclick", payLoad.start, payLoad.end);
        }
        SetClassNamesForEvents() {
            if (this.calendarEvents.length !== 0) {
                this.calendarEvents.forEach((event, index) => {
                    const classIndex = index % this.classesArray.length;
                    const className = this.classesArray[classIndex].className;
                    event.className = className;
                });
            }
        }
        handleEventMouseEnter(info) {
            this.popoverTarget = info.el;
            this.popoverData = {
                id: info.id,
                title: info.event.title,
                description: info.event.extendedProps.description,
            };
        }
        handleEventClick(info) {
            info.jsEvent.preventDefault();
            const eventUrl = info.event.url;
            if (eventUrl) {
                window.open(eventUrl, "_blank");
            }
        }
        get calendarOption() {
            return {
                headerToolbar: {
                    left: "prev,next today",
                    center: "title",
                    right: "dayGridMonth,timeGridWeek,listWeek",
                },
                buttonText: {
                    today: "This Month",
                },
                plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, bootstrapPlugin, listPlugin],
                initialView: "dayGridMonth",
                themeSystem: "bootstrap",
                initialEvents: calendarEvents,
                events: this.calendarEvents,
                weekends: true,
                editable: false,
                droppable: false,
                eventResizableFromStart: false,
                datesSet: this.handleMonthChange,
                eventMouseEnter: this.handleEventMouseEnter,
                dayMaxEvents: true,
                eventClick: this.handleEventClick,
            };
        }
        onCalendarEventsChange() {
            this.SetClassNamesForEvents();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], EcCalendar.prototype, "calendarEvents", void 0);
    __decorate([
        Watch("calendarEvents"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EcCalendar.prototype, "onCalendarEventsChange", null);
    EcCalendar = __decorate([
        Component({
            name: "EcCalendar",
            components: {
                Layout,
                PageHeader,
                Loader,
                FullCalendar,
            },
        })
    ], EcCalendar);
    return EcCalendar;
})();
export default EcCalendar;
